import { render, staticRenderFns } from "./CampaignPM.vue?vue&type=template&id=4cf268c0"
import script from "./CampaignPM.vue?vue&type=script&lang=js"
export * from "./CampaignPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports